import type { PromptDataDto } from "../../types/PromptDataDto";
import type { PromptDataEntity } from "../../types/PromptDataEntity";

export const PromptDataEntityToDto = ({ ...rest }: Readonly<PromptDataEntity>): PromptDataDto => {
    return {
        ...rest,
    };
};
